module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unfinished-item"
  }, [_c('div', {
    staticClass: "unfinished-item__file"
  }, [_c('p', {
    staticClass: "unfinished-item__file-name"
  }, [_vm._v(_vm._s(_vm.fileId))]), _vm._v(" "), _c('p', {
    staticClass: "unfinished-item__file-extension"
  }, [_vm._v(_vm._s(_vm.fileExt))])]), _vm._v(" "), _c('div', {
    staticClass: "file-info__controls"
  }, [_c('button', {
    staticClass: "button unfinished-item__file-check",
    on: {
      "click": _vm.onClick
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button unfinished-item__file-check",
    on: {
      "click": _vm.onRemoveClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticClass: "unfinished-item__hidden-input",
    attrs: {
      "type": "file",
      "accept": _vm.acceptedFiles
    },
    on: {
      "change": _vm.onFileChange
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15c41c08","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/uploadManager/ListItem.vue
// module id = 824
// module chunks = 0